export const COUNTRY_CODES = [
  'CV', 'PT', 'FR', 'NL', 'LU', 'BE', 'ES', 'IT', 'DE', 'CH', 'GB', 'IE', 'AT', 'SE', 'NO', 'DK',
  'FI', 'PL', 'US', 'CA', 'BR', 'AO', 'MZ', 'GW', 'ST', 'SN', 'MA', 'NG', 'GH', 'ZA', 'AE', 'IN',
  'CN', 'JP', 'AU', 'MX', 'AR',
];

export const REMOTE_LOCATION = 'Remoto, a partir de Cabo Verde';
export const CVE_PER_EUR = 110.265;
export const WORK_MODES = ['presencial', 'remoto', 'hibrido'];
export const CONTRACT_TYPES = ['contrato', 'prestacao_servicos'];
export const JOB_LANGUAGES = ['pt', 'en', 'fr', 'es', 'other'];

const LABELS = {
  pt: {
    workMode: 'Modalidade', contractType: 'Tipo de contrato', languages: 'Idiomas exigidos',
    presencial: 'Presencial', remoto: 'Remoto', hibrido: 'Híbrido',
    contrato: 'Contrato de trabalho', prestacao_servicos: 'Prestação de serviços (freelancer)',
    pt: 'Português', en: 'Inglês', fr: 'Francês', es: 'Espanhol', other: 'Outro',
    allModes: 'Todas as modalidades', notSpecified: 'Não especificado',
    remoteHint: 'Vaga remota: a localização fica "Remoto, a partir de Cabo Verde". Pode acrescentar a ilha (opcional).',
    approxEur: 'aprox.', remoteShortcut: 'Trabalho remoto', intlLink: 'Empresa no estrangeiro? Contrate à distância',
    country: 'País da empresa', foreignNifLabel: 'Número fiscal / registo da empresa',
    foreignNifHint: 'qualquer formato do seu país', foreignNifPlaceholder: 'Ex: PT123456789, 12.345.678-A',
    nifCvInvalid: 'O NIF de Cabo Verde deve ter 9 dígitos.', foreignNifRequired: 'O número fiscal / registo da empresa é obrigatório.',
  },
  en: {
    workMode: 'Work mode', contractType: 'Contract type', languages: 'Required languages',
    presencial: 'On-site', remoto: 'Remote', hibrido: 'Hybrid',
    contrato: 'Employment contract', prestacao_servicos: 'Service agreement (freelancer)',
    pt: 'Portuguese', en: 'English', fr: 'French', es: 'Spanish', other: 'Other',
    allModes: 'All work modes', notSpecified: 'Not specified',
    remoteHint: 'Remote job: location becomes "Remote, from Cape Verde". You may add the island (optional).',
    approxEur: 'approx.', remoteShortcut: 'Remote work', intlLink: 'Company abroad? Hire remotely',
    country: 'Company country', foreignNifLabel: 'Tax / company registration number',
    foreignNifHint: 'any format from your country', foreignNifPlaceholder: 'E.g. PT123456789, 12.345.678-A',
    nifCvInvalid: 'Cape Verde NIF must have 9 digits.', foreignNifRequired: 'The tax / registration number is required.',
  },
  fr: {
    workMode: 'Modalité', contractType: 'Type de contrat', languages: 'Langues requises',
    presencial: 'Présentiel', remoto: 'Télétravail', hibrido: 'Hybride',
    contrato: 'Contrat de travail', prestacao_servicos: 'Prestation de services (freelance)',
    pt: 'Portugais', en: 'Anglais', fr: 'Français', es: 'Espagnol', other: 'Autre',
    allModes: 'Toutes les modalités', notSpecified: 'Non précisé',
    remoteHint: 'Poste à distance : le lieu devient « Remoto, a partir de Cabo Verde ». Vous pouvez ajouter l\'île (facultatif).',
    approxEur: 'env.', remoteShortcut: 'Télétravail', intlLink: 'Entreprise à l\'étranger ? Recrutez à distance',
    country: 'Pays de l\'entreprise', foreignNifLabel: 'Numéro fiscal / d\'immatriculation',
    foreignNifHint: 'tout format de votre pays', foreignNifPlaceholder: 'Ex : FR12345678901, 123 456 789',
    nifCvInvalid: 'Le NIF du Cap-Vert doit comporter 9 chiffres.', foreignNifRequired: 'Le numéro fiscal / d\'immatriculation est obligatoire.',
  },
};

export const rwLabel = (lang, key) => (LABELS[(lang || 'pt').slice(0, 2)] || LABELS.pt)[key] || key;

export const countryName = (code, lang) => {
  try {
    return new Intl.DisplayNames([(lang || 'pt').slice(0, 2)], { type: 'region' }).of(code);
  } catch {
    return code;
  }
};

export const isForeignCompany = (user) => !!user?.company_country && user.company_country !== 'CV';

export const toEur = (cve) => Math.round((Number(cve) || 0) / CVE_PER_EUR);

export const applyWorkMode = (prev, mode) => {
  let location = prev.location || '';
  if (mode === 'remoto' && !location.startsWith(REMOTE_LOCATION)) location = REMOTE_LOCATION;
  if (mode !== 'remoto' && location.startsWith(REMOTE_LOCATION)) location = '';
  return { ...prev, work_mode: mode, location };
};
